import { IOnePageSections, ONE_PAGE_SECTIONS } from 'constants/businessToolSections/onePage';

import { AboutTheCompany } from './AboutTheCompany';
import { AboutTheProject } from './AboutTheProject';
import { FinancialProjections } from './FinancialProjections';
import { FinancingNeeds } from './FinancingNeeds';
import { MarketAndSales } from './MarketAndSales';
import { ProductsOrServices } from './ProductsOrServices';
import { Team } from './Team';
import { ImplementationPlan } from '../Sections/ImplementationPlan';

export type IOnePageFormSections = {
  [key in IOnePageSections]: React.ComponentType;
};

export const onePageFormSections: IOnePageFormSections = {
  [ONE_PAGE_SECTIONS.ABOUT_THE_COMPANY]: AboutTheCompany,
  [ONE_PAGE_SECTIONS.ABOUT_THE_PROJECT]: AboutTheProject,
  [ONE_PAGE_SECTIONS.PRODUCTS_SERVICES]: ProductsOrServices,
  [ONE_PAGE_SECTIONS.MARKET_AND_SALES]: MarketAndSales,
  [ONE_PAGE_SECTIONS.TEAM]: Team,
  [ONE_PAGE_SECTIONS.FINANCIAL_PROJECTIONS]: FinancialProjections,
  [ONE_PAGE_SECTIONS.FINANCING_NEEDS]: FinancingNeeds,
  [ONE_PAGE_SECTIONS.IMPLEMENTATION_PLAN]: ImplementationPlan,
};
